import { type dimeProgressBarToneTextClass } from './dime-progress-bar-tone-text-class.js';
import { cn } from './lib/utils.js';

type DimeProgressTone = Parameters<typeof dimeProgressBarToneTextClass>[0];

const FILL_BY_TONE: Record<DimeProgressTone, string> = {
  default: 'bg-primary',
  muted: 'bg-muted-foreground/40',
  success: 'bg-emerald-500',
  warning: 'bg-amber-500',
  destructive: 'bg-destructive',
};

/**
 * A slim completion bar for a ratio already stated in words or figures beside it — decorative by
 * design, so it carries `aria-hidden` and the caller keeps the accessible value in text.
 */
export function DimeProgressBar({
  percent,
  tone = 'default',
  className,
}: Readonly<{ percent: number; tone?: DimeProgressTone; className?: string }>) {
  const clamped = Number.isFinite(percent) ? Math.min(100, Math.max(0, percent)) : 0;

  return (
    <div
      aria-hidden="true"
      className={cn('h-1.5 w-full max-w-[4.5rem] overflow-hidden rounded-full bg-muted', className)}
    >
      <div
        className={cn('h-full rounded-full', FILL_BY_TONE[tone])}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
